import { useState } from "react";

const AirportSelector = ({ label, value, onChange, options, onSelect }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleInputChange = (e) => {
    const input = e.target.value;
    onChange(input);

    const filtered = options.filter(
      (airport) =>
        airport.city?.toLowerCase().includes(input.toLowerCase()) ||
        airport.iata?.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredOptions(filtered);
  };

  return (
    <div className="inputField">
      <label>{label}</label>
      <div className="dropdown dropdownHt">
        <input
          type="text"
          value={value}
          placeholder="Start typing City or Airport"
          onFocus={() => {
            setShowDropdown(true);
            setFilteredOptions(options);
          }}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)} // avoid closing before click
          onChange={handleInputChange}
        />
        {showDropdown && filteredOptions.length > 0 && (
          <ul className="dropdown-menu show" style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {filteredOptions.map((airport, index) => (
              <li
                key={index}
                onMouseDown={() => {
                  onSelect(`${airport.city} (${airport.iata})`);
                  setShowDropdown(false);
                }}
              >
                {airport.city} ({airport.iata})
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AirportSelector;
